var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupplyChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "supply--chain--optimization--01"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5596e6",
    id: "supply--chain--optimization--01_1_",
    d: "M10,31.36H2v-0.72h8V31.36z M11.36,30h-0.72v-8h0.72V30z M1.36,30H0.64v-8h0.72 V30z M20,21.36h-8v-0.72h8V21.36z M10,21.36H2v-0.72h8V21.36z M21.36,20h-0.72v-8h0.721L21.36,20L21.36,20z M11.36,20h-0.72v-8 h0.72V20z M15,18.36c-0.092,0-0.184-0.035-0.254-0.105l-2-2l0.509-0.509L15,17.491l3.745-3.746l0.51,0.509l-4,4 C15.184,18.325,15.092,18.36,15,18.36z M30,11.36h-8v-0.72h8V11.36z M20,11.36h-8v-0.72h8V11.36z M31.36,10h-0.72V2h0.721L31.36,10 L31.36,10z M21.36,10h-0.72V2h0.721L21.36,10L21.36,10z M30,1.36h-8V0.64h8V1.36z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyChain);
export default __webpack_public_path__ + "../static/product-explorer-main-offerings/assets/supply-chain.ffad93d189edb499f2ad2453d0571348.svg";
export { ForwardRef as ReactComponent };